import styled from "styled-components";
import { SE_CLIENT_HEIGHT } from "../../constants/data";
import gradientImg from "./../../resources/images/main/gradient.png";

const FinishBlock = styled.div``;

FinishBlock.Img = styled.div`
  z-index: -1;
  img {
    width: 250px;
    @media (max-height: ${SE_CLIENT_HEIGHT}px) {
      width: 200px;
    }
  }
`;
FinishBlock.Gradient = styled.div`
  position: fixed;
  bottom: 0;
  width: 100%;
  height: 50%;
  left: 0;
  background: url(${gradientImg});
  background-size: 100% 100%;
  //background: linear-gradient(180deg, rgba(5, 2, 55, 0) 0.01%, #050237 28.49%);
`;

export { FinishBlock };
